import {createElement, Component, PropTypes} from 'rlink-react';
import {xhr} from 'rlink-utils/xhr';
import ShopProvider from 'rlink-shop/service/base';
import navActions from 'rlink-router/actions';
import Region from 'rlink-regions/Region';
import getRegionForCountry from 'rlink-regions/getRegionForCountry';

export class ScalefastService extends ShopProvider {
  constructor (skuGroups) {
    super();
    this.apiEndPoint = 'https://api.scalefast.com/products';
    this.storefrontUrl = 'https://store.dawnofwar.com';
    this.cartUrl = 'https://store.dawnofwar.com';
    this.skuGroups = skuGroups;
  }

  apiRequest (options) {
    let url = this.apiEndPoint;
    let params = Object.assign(options, {
      clientID: 'C0E70E8DCE29650906F20831435F3839',
    });


    return xhr('GET', url, params, {withCredentials: false});
  }

  parseScalefastResponse (response, currency) {
    let productObjects = response.response_data.objects;
    let currencies = productObjects[0].price_info.currencies;
    let price = currencies[currency].prices[0].price;
    let disable = false;
    if ('stock' in productObjects[0] && 'stock' in productObjects[0].stock) {
      disable = (productObjects[0].stock.stock <= 0);
    }
    let data = {
      productID: productObjects[0].productID,
      normalPrice: {
        amount: price,
        currency,
      },
      disable,
      //salePrice: price,
    };

    return data;
  }

  _getPrice (scalefastId, userCountry) {
    let region = getRegionForCountry(userCountry, this.skuGroups, {});
    let options = {
      refID: scalefastId,
      country: region.skuGroup,
    };

    return this.apiRequest(options).then(responseRaw => {
      let response = JSON.parse(responseRaw.response);

      if (response.result.errcode !== '0') {
        console.warn(JSON.stringify({
          error: response.result.status,
          message: response.result.msg,
        }));
        return this._getFallbackPrice(scalefastId);
      } else {
        let productObjects = response.response_data.objects;
        if (productObjects.length > 0) {
          let currency = productObjects[0].price_info.currency;
          return this.parseScalefastResponse(response, currency);
        } else {
          return this._getFallbackPrice(scalefastId);
        }
      }
    }).catch(error => {
      if (error === undefined) {
        error = {};
      }

      if (error.error === undefined) {
        error.error = 'SERVER_ERROR';
      }
      console.error(error);
    });
  }

  _getFallbackPrice (scalefastId) {
    let options = {
      refID: scalefastId,
      country: 'ROW',
    };

    return this.apiRequest(options).then(responseRaw => {
      let response = JSON.parse(responseRaw.response);

      if (response.result.errcode !== '0') {
        console.warn(JSON.stringify({
          error: response.result.status,
          message: response.result.msg,
        }));
      } else {
        let productObjects = response.response_data.objects;
        if (productObjects.length > 0) {
          let currency = productObjects[0].price_info.currency;
          return this.parseScalefastResponse(response, currency);
        }

        return {};
      }
    }).catch(error => {
      if (error === undefined) {
        error = {};
      }

      if (error.error === undefined) {
        error.error = 'SERVER_ERROR';
      }
      console.error(error);
    });
  }

  getPurchaseHref (ev) {
    return `${this.cartUrl}/${ev.purchaseIdentifier}?productid=${ev.productID}`;
  }

  getMoreInfoHref (product) {
    return `${this.storefrontUrl}/${product.purchaseIdentifier}`;
  }

  _getModalContent (identifier, size) {
    return [];
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-shop/service/Scalefast.jsx